// ==========================================
// frontend/src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* À propos */}
          <div>
            <Logo size="lg" textColor="text-white" className="mb-4" />
            <p className="text-gray-400 mb-4">
              Votre partenaire de confiance pour des solutions d'ingénierie innovantes et de qualité.
            </p>
            <SocialLinks />
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="text-xl font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/realizations" className="text-gray-400 hover:text-white transition-colors">
                  Réalisations
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>📞 (+216) 51 418 880 / 51 418 873</li>
              <li>
                📧 contact@seengineering-tn.com
              </li>
              <li>📧 seengineering.tn@gmail.com</li>
              <li>📍 12 Rue 18 janvier, KSIBET EL MEDIOUNI 5031- Tunisie</li>
              <li>🕒 Lun-Ven: 8h-17h</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} SE Engineering. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


